<!-- 行业案例-装修行业 -->
<template>
  <div class="box">
    <CaseDemo :mydata="caseDataList[9]" :topTextColor='topTextColor'></CaseDemo>
  </div>
</template>

<script>
import Vue from "vue";

import CaseDemo from "./../../components/CaseDemo";
import { caseDataList } from "./caseDataList.js";

export default {
  data() {
    return {
      caseDataList,
      // caseDataList:caseDataList,
      topTextColor:'#fff'
    };
  },
  components: {
    CaseDemo,
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style lang='sass' scoped>

</style>